import React from 'react';
import { useParams } from 'react-router-dom';

import ComponentEditor from './editor';

export default function EditComponent() {
    const {
        level = '',
        skill = '',
        componentId = ''
    } = useParams();

    return (
        <ComponentEditor
            isNew={false}
            level={level}
            skill={skill}
            componentId={componentId}
        />
    );
}